/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa Currency Converter
 *
 */
Intesa.CalculatorNavigation = function(activeCalculator) {
	
    /**
	 *  Variables
	 *
	 */
	var bankName = $("[data-bank]").attr('data-bank');
	var calculatorNavigation = this;
	this.currentTab = 0;
	this.tabDesktop;
	this.tabMobile;
	this.activeCalculator = activeCalculator;

	/**
	 * Init component
	 *
	 */
	this.init = function() {		
		calculatorNavigation.tabDesktop = $(".tab", calculatorNavigation.activeCalculator);
		calculatorNavigation.tabMobile = $(".tab-mobile", calculatorNavigation.activeCalculator);
		
		$(document).on('click', '.js-calculator-close',function(e) {
			var navigator = calculatorNavigation;

			var $calculator = $('.calculator-mobile');
			$('body').removeClass('calculator-mobile-open');

			$calculator.hide();

			navigator.closeCalculator();
		});
		//Edit Loan informations
		$(document).on('click', '.js-your-data-edit-li',function(e) {
			e.preventDefault();
			var navigator = calculatorNavigation;
			navigator.hideResults(this);
			navigator.goToTab(0);
		});
		//Edit Personal informations
		$(document).on('click', '.js-your-data-edit-pi',function(e) {
			e.preventDefault();
			var navigator = calculatorNavigation;

			var tabsMobile = document.getElementsByClassName("tab-mobile");

			for(var tab = 0; tab < tabsMobile.length; tab++) {
				if(tabsMobile[tab].hasAttribute('data-start-personal-information'))
					break;
			}

			navigator.hideResults(this);
			navigator.goToTab(tab);
		});

		
		
		// Current tab is set to be the first tab (0)
		//calculatorNavigation.showTab(currentTab); // Display the current tab

	}

	
	this.showTab = function(n) {
	  // This function will display the specified tab of the form...
		console.log("current index " + calculatorNavigation.currentTab);
	  if(calculatorNavigation.tabDesktop.length > 0 || calculatorNavigation.tabMobile.length > 0){
	  	if(window.innerWidth > 768){
			calculatorNavigation.tabDesktop.parents(".calculator-desktop")[0].getElementsByClassName("tab")[n].style.display = "block";
		} else {
			calculatorNavigation.tabMobile.parents(".calculator-mobile")[0].getElementsByClassName("mobile-loan")[n].getElementsByClassName("tab-mobile")[0].style.display = "block";
	 	}
	  }
	  //... and run a function that will display the correct step indicator:
	  //TODO calculatorNavigation.fixStepIndicator(n);
	}
	
	this.checkNextPrev = function(n, currentIndex){
		if(n < 0 && currentIndex == 0){
			return 0;
		} 
//		else if(n > 0 && currentIndex == 0) {
//			return n + currentIndex;
//		} 
		else {
			return n + currentIndex;
		}
		
	}
	
	this.showExactTab = function(tabClass){
		$(".result-tab", calculatorNavigation.activeCalculator).hide();
		$(tabClass).show();
		var allTabs = $("tab-mobile", calculatorNavigation.activeCalculator);
		var cssClass = tabClass.replace(".", "");
		for(var c = 0; c < allTabs.length ; c++){
			if(allTabs.get(c).classList.contains(cssClass)){
				calculatorNavigation.currentTab = c;
			}
			
		}
		
	}
	
	this.nextPrev = function(n, element) {
		console.log("element" + element);
		calculatorNavigation.tabDesktop = $(element).parents(".tab");
		calculatorNavigation.tabMobile = $(element).parents(".tab-mobile");
		
		if(calculatorNavigation.tabDesktop.length > 0){
			calculatorNavigation.activeCalculator = $(element).parents(".calculator-desktop");
		}
		if(calculatorNavigation.tabMobile.length > 0){
			calculatorNavigation.activeCalculator = $(element).parents(".calculator-mobile");
		}
	  if(calculatorNavigation.tabDesktop.length > 0 || calculatorNavigation.tabMobile.length > 0){
		  calculatorNavigation.hideCurrentTab();
		  // Increase or decrease the current tab by 1:
		  calculatorNavigation.currentTab = calculatorNavigation.checkNextPrev(n, calculatorNavigation.currentTab);
		  // if you have reached the end of the form...
		  // Otherwise, display the correct tab:
		  calculatorNavigation.showTab(calculatorNavigation.currentTab);
	  }
	}
	
	this.fixStepIndicator = function (n) {
		  // This function removes the "active" class of all steps...
		  var i, x = document.getElementsByClassName("step");
		  for (i = 0; i < x.length; i++) {
		    x[i].className = x[i].className.replace(" active", "");
		  }
		  //... and adds the "active" class on the current step:
		  x[n].className += " active";
		}
	
	this.goToTab = function(n) {
		if(calculatorNavigation.tabDesktop.length > 0 || calculatorNavigation.tabMobile.length > 0){
			//calculatorNavigation.hideCurrentTab();
			if(calculatorNavigation.tabDesktop.length > 0 )
			calculatorNavigation.tabDesktop.parents(".calculator-desktop")[0].getElementsByClassName("tab")[calculatorNavigation.currentTab].style.display = "none";
			if(calculatorNavigation.tabMobile.length > 0){
				var tabsMobile = document.getElementsByClassName("tab-mobile");
	
				for(var tab = 0; tab < tabsMobile.length; tab++) {
					if(tab != n){
						tabsMobile[tab].style.display = "none";
					}
				}
			}
			
			calculatorNavigation.currentTab = n;

			calculatorNavigation.showTab(calculatorNavigation.currentTab);

			//document.querySelector('.calculator-mobile').scrollIntoView();
		}
	}
	
	this.nextPrevLast = function(n) {
	  if(calculatorNavigation.tabDesktop.length > 0 || calculatorNavigation.tabMobile.length > 0){
		  this.hideCurrentTab();
		  // Increase or decrease the current tab by 1:
		  calculatorNavigation.currentTab = calculatorNavigation.checkNextPrev(n, calculatorNavigation.currentTab);
		  // if you have reached the end of the form...
	  }
	}
	
	this.showResults = function(n){
		calculatorNavigation.nextPrevLast(n);
		$(".results-side", calculatorNavigation.activeCalculator).attr("style", "display:block");
	}
	
	this.hideResults = function(element){
		$($(element).parents(".tab-mobile")[0]).attr("style", "display:none");
	}

	this.hideCurrentTab = function() {
		if(calculatorNavigation.tabDesktop.length > 0 || calculatorNavigation.tabMobile.length > 0){
			if(window.innerWidth > 768){
				calculatorNavigation.tabDesktop.css("display", "none");
			} else {
				calculatorNavigation.tabMobile.css("display", "none");
			}
		}
	}

	this.closeCalculator = function() {
		this.goToTab(0);
	}


};

/**
 * Get class instance
 *
 */
Intesa.CalculatorNavigation.getInstance = function(activeCalculator) {
	
	if( !window.intesa ) {
		
		window.intesa = new Object();
		
	}
	if( !window.intesa.calculatorNavigation ) {
		
		window.intesa.calculatorNavigation = new Intesa.CalculatorNavigation(activeCalculator);
		
	}
	
	return window.intesa.calculatorNavigation;

};